import * as FormationTypeTypes from './formationTypeTypes';

const initialState = {
    items: [],
    initialized: false,

    error: undefined,
};

export const FormationTypeReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FormationTypeTypes.SET_INITIALIZED:
            return {
                ...state,
                initialized: action.payload.initialized,
            };
        case FormationTypeTypes.SET_ITEMS:
            return {
                ...state,
                items: action.payload.items,
            };
        case FormationTypeTypes.SET_ERROR:
            return {
                ...state,
                error: action.payload.error,
            };
        default:
            return state;
    }
};
